var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgMinuse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065ZM6.28327 5.71774C6.12706 5.56153 5.87379 5.56153 5.71758 5.71774C5.56137 5.87395 5.56137 6.12722 5.71758 6.28343L7.43474 8.00059L5.71758 9.71774C5.56137 9.87395 5.56137 10.1272 5.71758 10.2834C5.87379 10.4396 6.12706 10.4396 6.28327 10.2834L8.00042 8.56627L9.71758 10.2834C9.87379 10.4396 10.1271 10.4396 10.2833 10.2834C10.4395 10.1272 10.4395 9.87395 10.2833 9.71774L8.56611 8.00059L10.2833 6.28343C10.4395 6.12722 10.4395 5.87395 10.2833 5.71774C10.1271 5.56153 9.87379 5.56153 9.71758 5.71774L8.00042 7.4349L6.28327 5.71774Z",
    fill: "#979998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMinuse);
export default __webpack_public_path__ + "static/media/imgMinuse.e7e0fa2e4fc5437fa906eafd75bce432.svg";
export { ForwardRef as ReactComponent };